import script from "./PbxExtensionsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxExtensionsPanel.vue?vue&type=script&setup=true&lang=js"

import "./PbxExtensionsPanel.vue?vue&type=style&index=0&id=69b9f1dd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b9f1dd"]])

export default __exports__